/** Relative time like "2 hours ago", "Yesterday", "3 days ago". */
export function formatRelativeTime(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  const now = Date.now();
  const diffMs = Math.max(0, now - date.getTime());
  const sec = Math.floor(diffMs / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);

  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);

  if (sec < 45) return 'just now';
  if (min < 1) return '1 minute ago';
  if (min < 60) return `${min} minutes ago`;
  if (hr < 2) return '1 hour ago';
  if (hr < 24) return `${hr} hours ago`;

  if (date >= startOfYesterday && date < startOfToday) return 'Yesterday';

  const startOfEvent = new Date(date);
  startOfEvent.setHours(0, 0, 0, 0);
  const dayDiff = Math.round(
    (startOfToday.getTime() - startOfEvent.getTime()) / (24 * 60 * 60 * 1000)
  );
  if (dayDiff === 1) return 'Yesterday';
  if (dayDiff >= 2 && dayDiff < 7) return `${dayDiff} days ago`;
  if (dayDiff === 7) return '1 week ago';
  if (dayDiff > 7 && dayDiff < 30) return `${Math.floor(dayDiff / 7)} weeks ago`;

  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

/** e.g. "Today at 9:41 AM" for same calendar day, else localized date + time. */
export function formatLastChecked(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startOfTomorrow = new Date(startOfToday);
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1);

  const timeStr = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });

  if (date >= startOfToday && date < startOfTomorrow) {
    return `Today at ${timeStr}`;
  }

  const yesterday = new Date(startOfToday);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date >= yesterday && date < startOfToday) {
    return `Yesterday at ${timeStr}`;
  }

  return `${date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })} at ${timeStr}`;
}

/** Monday 00:00:00 local for "this week" boundaries. */
export function startOfWeekMonday(d = new Date()): Date {
  const x = new Date(d);
  const day = x.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  x.setDate(x.getDate() + diff);
  x.setHours(0, 0, 0, 0);
  return x;
}
